module.exports = __webpack_public_path__ + "img/OAX.b1db3dfa.svg";